<template>
  <div class="row" style="min-height: calc(100vh - 56px);padding:0;margin: 0;background-color: #e9f2ff">
    <Loading :active.sync="isLoading"
             :is-full-page="isFullPage"></Loading>
      <div class="col-md-4" style="height: 100%">
        <div style="padding: 20px">
        <p style="font-weight: bold">
          Değerli öğrencimiz,
        </p>
<!--        <p>-->
<!--          sinavanaliz.ankaradil.com üzerinden sınav değerlendirmenizi yapabilmek için, aktif bir Canlı / Kayıttan ders öğrencisi olmanız ya da öğretmenlerimizden aktivasyon kodu almış olmanız gereklidir.-->
<!--        </p>-->
        <p>
          Hangi sınavı değerlendirmek istiyorsunuz?
        </p>
        <div class="col-md-12 text-center"><font-awesome-icon :icon="['fal', 'stars']" size="6x"/></div>
        </div>
      </div>
      <div class="col-md-7 h-100" style="padding-left: 10px;padding-top: 20px">
        <b-alert variant="danger"
                 dismissible
                 :show="hata!==''"
                 @dismissed="hata=''">
          {{hata}}
        </b-alert>
        <div v-if="kullanicipaketleri.length == 0" style="padding-top: 50px" class="container justify-content-center align-items-center">
          <div class="col-md-12 text-center"><font-awesome-icon :icon="['fal', 'sad-tear']" size="6x" /></div>
          <div class="col-md-12 text-center"><p>Analiz edebileceğiniz bir sınav yok veya aktif bir canlı / kayıttan öğrencimiz değilsiniz.</p></div>
          <div class="col-md-12 text-center"><h3>Öğretmenlerimizden Aktivasyon Kodu Aldıysanız aşağıdaki alana yazabilirsiniz </h3></div>
          <div class="form-label-group">
            <label for="txtkod">Aktivasyon Kodunuz</label>
            <input v-model="kod"  type="text" id="txtkod" class="form-control" placeholder="Aktivasyon Kodunuz">
          </div>
          <div>
            <b-button size="sm" variant="success" v-on:click="activateCode"  class="mr-2">
              Aktivasyon Yap
            </b-button>
          </div>
        </div>
        <div v-if="kullanicipaketleri.length > 0">
          <h3>Analiz Edebileceğiniz Sınavlar</h3>
<!--          <b-list-group>-->
<!--            <b-list-group-item  v-for="(item, index) in kullanicipaketleri"   v-bind:item="item"   v-bind:index="index"  v-bind:key="item._id" >-->
              <div class="row">
                <b-table :items="kullanicipaketleri" :fields="fields" :responsive="true">
                  <template slot="table-caption">
                    Sınav analizini yaparak, bir daha ki sınava nasıl çalışacağınızın kararını verin.
                  </template>
                  <template slot="_id" slot-scope="row">
                    <!--<router-link to="/sinav"></router-link>-->
                    <b-button size="sm" :to="{name: 'Sinav', params: { sinavid: row.value }}" variant="success" class="mr-2">
                      Sınav Analizi
                    </b-button>
                  </template>
                  <template v-if="row.item.cozulenDenemeId" slot="istatistikler" slot-scope="row">
                    <b-button size="sm" :to="{name: 'SinavOzeti', params: { sinavid: row.item.cozulenDenemeId }}" variant="primary" class="mr-2">
                      Sınav Özeti ve Değerlendirme Sonuçları
                    </b-button>
                  </template>
                  <!--<template  slot="videourl" slot-scope="data">-->
                    <!--<b-button v-show="data.item.videourl || data.item.embedcode"  :to="{name: 'VideoGoster', params: { url:data.item.videourl, videoadi: data.item.denemeAdi, embedcode: data.item.embedcode }}" size="sm" variant="primary" class="mr-2">-->
                      <!--Çözüm Videosu İzle-->
                    <!--</b-button>-->
                    <!--<label v-show="!data.item.videourl && !data.item.embedcode"  >Bu denemeye ait video çözüm bulunamadı</label>-->
                  <!--</template>-->
<!--                  <template  slot="videourl" slot-scope="data">-->
<!--                    <b-button v-show="data.item.videourl || data.item.embedcode"  :to="{name: 'VideoGoster', params: { url:data.item.videourl, videoadi: data.item.denemeAdi, embedcode: data.item.embedcode }}" size="sm" variant="primary" class="mr-2">-->
<!--                      Çözüm Videosu İzle-->
<!--                    </b-button>-->
<!--                    <label v-show="!data.item.videourl && !data.item.embedcode"  >Bu denemeye ait video çözüm bulunamadı</label>-->
<!--                  </template>-->
                </b-table>
              </div>
<!--            </b-list-group-item>-->
<!--          </b-list-group>-->
        </div>
      </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
export default {
  name: 'UserMain',
  data () {
    return {
      kod: '',
      kullanicipaketleri: [],
      isLoading: true,
      fields: [{ key: 'sinavAdi', label: 'Sınav Adı' },
        // { key: 'denemeAciklamasi', label: 'Açıklama' },
        { key: '_id', label: 'Sınav Analizi', variant: 'success' },
        // { key: 'videourl', label: 'Video Çözüm', variant: 'primary' },
        { key: 'istatistikler', label: 'Sınav Özeti', variant: 'primary' }
      ],
      isFullPage: true
    }
  },
  components: {
    Loading
  },
  computed: mapState([
    'user', 'hata'
  ]),
  methods: {
    ...mapActions([
      'setError_ACTION'
    ]),
    checkUser () {
      axios
        .post(this.$serviceAddress + 'api/v5/getAnalizMembership', {
          token: this.user.token
        })
        .then((response) => {
          this.kullanicipaketleri = response.data || []
          this.isLoading = false
        }).catch((e) => {
          this.isLoading = false
          console.log(e)
        })
      if (this.hata === '') {
        console.log('Hata Yok!')
      } else {
        console.log(this.hata)
        this.setError_ACTION('')
      }
    },
    sinavabasla () {
    },
    activateCode () {
      axios
        .post(this.$serviceAddress + 'api/v5/postAnalizActivationCode', {
          token: this.user.token,
          kod: this.kod
        })
        .then((response) => {
          if (response.data.result === 1) {
            console.log('Aktivasyon Yapıldı')
            alert('Aktivasyonunuz yapıldı!')
            this.checkUser()
          } else {
            alert('Aktivasyon hatası. ' + response.data.err)
          }
          this.isLoading = false
        }).catch((e) => {
          this.isLoading = false
          console.log(e)
        })
      if (this.hata === '') {
        console.log('Hata Yok!')
      } else {
        console.log(this.hata)
        this.setError_ACTION('')
      }
    }
  },
  mounted () {
    this.checkUser()
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UserMain.vue